"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
exports.setDeviceMetadataAction = exports.deviceMetadataReducer = exports.DEVICE_METADATA_REDUCER_NAME = exports.DeviceMetadataSlice = exports.deviceMetadataInitialState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
exports.deviceMetadataInitialState = {
    initialized: false,
    deviceId: undefined
};
exports.DeviceMetadataSlice = (0, toolkit_1.createSlice)({
    name: 'deviceMetadata',
    initialState: exports.deviceMetadataInitialState,
    reducers: {
        setDeviceMetadataAction: function (state, action) {
            state.initialized = action.payload.initialized;
            state.deviceId = action.payload.deviceId;
        }
    }
});
exports.DEVICE_METADATA_REDUCER_NAME = exports.DeviceMetadataSlice.name;
exports.deviceMetadataReducer = exports.DeviceMetadataSlice.reducer;
exports.setDeviceMetadataAction = exports.DeviceMetadataSlice.actions.setDeviceMetadataAction;
__exportStar(require("./types"), exports);
